import * as types from '../constants/actionTypes';
import initialState from './initialState';
import findIndex from 'lodash.findindex';
import { sortQuickMessage } from '../functions/utils';

export default function quickMessageReducer(state = initialState.quickMessages, action) {
  switch (action.type) {
    case types.LOAD_QUICK_MESSAGE_SUCCESS: {
      return sortQuickMessage([...action.quickMessages]);
    }
    case types.ADD_QUICK_MESSAGE_SUCCESS: {
      const _quickMessagesAdd = [...state].concat(action.quickMessage);
      return sortQuickMessage([..._quickMessagesAdd]);
    }
    case types.UPDATE_QUICK_MESSAGE_SUCCESS: {
      const _index = findIndex(state, e => {
        return e.templateId === action.quickMessage.templateId;
      });

      const _quickMessagesUpdate = [...state];
      if (_index >= 0) {
        _quickMessagesUpdate[_index] = action.quickMessage;
      }
      return [..._quickMessagesUpdate];
    }
    case types.DELETE_QUICK_MESSAGE_SUCCESS: {
      return [...state.filter(m => m.templateId !== action.quickMessage.templateId)];
    }
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.quickMessages;
      return state;
    }
    default:
      return state;
  }
}
